/* eslint-disable import/no-commonjs */

// 直接导入字体文件，webpack会将它们处理为URL或Data URL
const SansSerif = require('./NotoSans-Medium.woff2');
const Serif = require('./SourceSerifPro-Regular.woff2');
const Handwriting = require('./handlee-regular.woff2');
const Marker = require('./Knewave.woff2');
const Curly = require('./Griffy-Regular.woff2');
const Pixel = require('./Grand9K-Pixel.woff2');
const Scratch = require('./ScratchSavers_b2.woff2');

// 调试：输出字体URL类型
console.log('字体URL类型:');
console.log(`Sans Serif: ${SansSerif.startsWith('data:') ? 'Data URL' : 'HTTP/File URL'}`);
console.log(`Serif: ${Serif.startsWith('data:') ? 'Data URL' : 'HTTP/File URL'}`);
console.log(`Handwriting: ${Handwriting.startsWith('data:') ? 'Data URL' : 'HTTP/File URL'}`);
console.log(`Marker: ${Marker.startsWith('data:') ? 'Data URL' : 'HTTP/File URL'}`);
console.log(`Curly: ${Curly.startsWith('data:') ? 'Data URL' : 'HTTP/File URL'}`);
console.log(`Pixel: ${Pixel.startsWith('data:') ? 'Data URL' : 'HTTP/File URL'}`);
console.log(`Scratch: ${Scratch.startsWith('data:') ? 'Data URL' : 'HTTP/File URL'}`);
const log = require('../log').default;

const fontSource = {
    'Sans Serif': SansSerif,
    'Serif': Serif,
    'Handwriting': Handwriting,
    'Marker': Marker,
    'Curly': Curly,
    'Pixel': Pixel,
    'Scratch': Scratch
};

const fontData = {};

const fetchFonts = () => {
    const promises = [];
    console.log('开始加载字体:', Object.keys(fontSource));
    for (const fontName of Object.keys(fontSource)) {
        console.log(`加载字体: ${fontName}, URL: ${fontSource[fontName]}`);
        
        // 检查字体URL是否是data URL（已内联）或需要fetch
        if (fontSource[fontName].startsWith('data:')) {
            // 如果是data URL，直接使用
            console.log(`字体 ${fontName} 是data URL，直接使用`);
            const fontRule = `@font-face{font-family:"${fontName}";src:url("${fontSource[fontName]}");font-weight:normal;font-style:normal;}`;
            fontData[fontName] = fontRule;
            console.log(`生成字体规则: ${fontName}`, fontRule);
            promises.push(Promise.resolve());
        } else {
            // 否则使用fetch加载
            promises.push(fetch(fontSource[fontName])
                .then(res => {
                    console.log(`字体 ${fontName} 加载响应: ${res.status} ${res.statusText}`);
                    if (!res.ok) {
                        throw new Error(`Cannot load font: ${fontName} (invalid HTTP response: ${res.status})`);
                    }
                    return res.blob();
                })
                .then(blob => new Promise((resolve, reject) => {
                    const fr = new FileReader();
                    fr.onload = () => resolve(fr.result);
                    fr.onerror = () => reject(new Error(`Cannot load font: ${fontName} (could not read)`));
                    fr.readAsDataURL(blob);
                }))
                .then(url => {
                    const fontRule = `@font-face{font-family:"${fontName}";src:url("${url}");font-weight:normal;font-style:normal;}`;
                    fontData[fontName] = fontRule;
                    console.log(`生成字体规则: ${fontName}`, fontRule);
                })
                .catch(err => {
                    console.error(`字体 ${fontName} 加载失败:`, err);
                    log.error(err);
                })
            );
        }
    }
    return Promise.all(promises);
};

const addFontsToDocument = () => {
    if (document.getElementById('scratch-font-styles')) {
        console.log('字体样式元素已存在，跳过添加');
        return;
    }
    let css = '';
    for (const fontName of Object.keys(fontSource)) {
        const fontCSS = fontData[fontName];
        if (fontCSS) {
            css += fontCSS;
            console.log(`添加字体CSS规则: ${fontName}`);
        } else {
            console.warn(`字体 ${fontName} 没有生成CSS规则`);
        }
    }
    console.log('生成的完整CSS:', css);
    const documentStyleTag = document.createElement('style');
    documentStyleTag.id = 'scratch-font-styles';
    documentStyleTag.textContent = css;
    document.body.insertBefore(documentStyleTag, document.body.firstChild);
    console.log('字体样式元素已添加到文档');
};

const waitForFontsToLoad = () => {
    const promises = [];
    if (document.fonts && document.fonts.load) {
        for (const fontName in fontData) {
            promises.push(document.fonts.load(`12px ${fontName}`));
        }
    }
    return Promise.all(promises);
};

const loadFonts = () => fetchFonts()
    .then(() => {
        addFontsToDocument();
        return waitForFontsToLoad();
    })
    .catch(err => {
        log.error(err);
    });

const getFonts = () => fontData;

// We have to use legacy module.exports as some parts of Scratch expect require('scratch-render-font') to be a function
module.exports = getFonts;
module.exports.loadFonts = loadFonts;
module.exports.FONTS = fontData;
